export default __webpack_public_path__ + "static/media/comet.89be7e83.jpg";